module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-700.171ccc8.woff2";